import { ArrowLeft } from 'lucide-react'
import { Button } from '~/shadcn/ui/button/button'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'

type Props = {
  onBack: () => void
  onExport: () => void
  exportDisabled: boolean
}

export function DetailHeader({ onBack, onExport, exportDisabled }: Props) {
  const isDesktop = useIsDesktop()

  return (
    <div className="flex flex-col">
      <Button
        variant="ghost"
        onClick={onBack}
        className="h-9 self-start gap-1 px-0">
        <ArrowLeft className="text-accent" />
        <span className="text-sm font-bold text-accent">Vrátiť späť</span>
      </Button>
      <div className="flex flex-row justify-between items-center">
        {isDesktop && <HeadingThree>Detail ambasádora</HeadingThree>}
        <Button
          variant="ghost"
          disabled={exportDisabled}
          onClick={onExport}
          className="h-7">
          <span className="text-sm font-bold text-accent underline">
            Export XLSX
          </span>
        </Button>
      </div>
    </div>
  )
}
